var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPricebookHierarchyArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 27,
  height: 38,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#71777C",
  d: "M26.354 26.354a.5.5 0 0 0 0-.708l-3.182-3.181a.5.5 0 1 0-.707.707L25.293 26l-2.828 2.828a.5.5 0 1 0 .707.707zM11.5 0v20h1V0zM18 26.5h8v-1h-8zM11.5 20a6.5 6.5 0 0 0 6.5 6.5v-1a5.5 5.5 0 0 1-5.5-5.5z"
})));
export { SvgPricebookHierarchyArrow as ReactComponent };
export default __webpack_public_path__ + "static/media/pricebook-hierarchy-arrow.a94e0e4a.svg";